var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlugType3Medium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,36c-2.2060547,0-4,1.7939453-4,4s1.7939453,4,4,4s4-1.7939453,4-4S26.2060547,36,24,36z M24,42 c-1.1025391,0-2-0.8974609-2-2s0.8974609-2,2-2s2,0.8974609,2,2S25.1025391,42,24,42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,26c-2.2060547,0-4,1.7939453-4,4s1.7939453,4,4,4s4-1.7939453,4-4S32.2060547,26,30,26z M30,32 c-1.1025391,0-2-0.8974609-2-2s0.8974609-2,2-2s2,0.8974609,2,2S31.1025391,32,30,32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,30c0-2.2060547-1.7939453-4-4-4s-4,1.7939453-4,4s1.7939453,4,4,4S22,32.2060547,22,30z M18,32 c-1.1025391,0-2-0.8974609-2-2s0.8974609-2,2-2s2,0.8974609,2,2S19.1025391,32,18,32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,18c0,2.2060547,1.7939453,4,4,4s4-1.7939453,4-4s-1.7939453-4-4-4S26,15.7939453,26,18z M32,18 c0,1.1025391-0.8974609,2-2,2s-2-0.8974609-2-2s0.8974609-2,2-2S32,16.8974609,32,18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,22c2.2060547,0,4-1.7939453,4-4s-1.7939453-4-4-4s-4,1.7939453-4,4S15.7939453,22,18,22z M18,16 c1.1025391,0,2,0.8974609,2,2s-0.8974609,2-2,2s-2-0.8974609-2-2S16.8974609,16,18,16z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 10,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 10,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0c-7.7197266,0-14,6.2802734-14,14v20c0,7.7197266,6.2802734,14,14,14s14-6.2802734,14-14V14 C38,6.2802734,31.7197266,0,24,0z M36,34c0,6.6171875-5.3828125,12-12,12s-12-5.3828125-12-12V14c0-6.6171875,5.3828125-12,12-12 s12,5.3828125,12,12V34z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugType3Medium);
export default __webpack_public_path__ + "static/media/plug-type-3--medium.f73a54226911c87b4b61db6c0022d7be.svg";
export { ForwardRef as ReactComponent };